import createHistory from 'history/createHashHistory';

const history = createHistory();
export default history;
